/** Backend API wrapper */

// prod
function get_base_domain() {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        return "http://localhost:8000" //"https://api.convo4.soclearn.org"
    } else {
        return "https://api.convolution.soclearn.org"
    }

}

export const base_domain = get_base_domain()

const base_url = `${base_domain}/api/`

import { FileTransfer } from '@capacitor/file-transfer';
import { get } from './preferences'

const _fetch = window.fetch;
const fetch = async (url: string, options = {}) => {
    return await _fetch(url, { credentials: "include", ...options })
}

// docs

export async function dir_create(name: string, parent_id: number | null = null) {
    const r = await fetch(base_url + 'dirs',
        {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ name, parent_id })
        }
    )
    const data = await r.json()

    return data
}

export async function dir_get(id: number | string | null) {
    const r = id ? await fetch(base_url + `dirs/${id}`) : await fetch(base_url + `dirs`);
    const data = await r.json();
    return data
}

export async function dir_delete(id: number | string) {
    await fetch(base_url + `dirs/${id}`, { method: "DELETE" })
}

export async function dir_change(id: number, name: string) {
    const r = await fetch(base_url + 'dirs/change',
        {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id, name })
        }
    )
    const data = await r.json()

    return data
}

async function upload_doc(file: File, onProgress: null | ((progress: number) => void) = null, dir_id: string | null = null) {
    const user_id = await get("user_id")
    const user_key = await get("user_key")
    const url = base_url + "docs" + `?user_id=${user_id}&user_key=${user_key}` + (dir_id ? `&dir_id=${dir_id}` : '') // FIXME: probably a hack, also need user_key maybe? otherwise anyone can upload to this user; or maybe that's a feature idk
    const filePath = file.name;
    if (onProgress) {
        await FileTransfer.addListener("progress", (progress) => {
            // Update progress state with the percentage
            onProgress(progress.bytes/progress.contentLength);
        });
    }
    await FileTransfer.uploadFile({
        url,
        path: filePath,
        blob: file,
        progress: true
    })
}

async function docs(folder_id: number | null) {
    const r = await fetch(base_url + `docs` + folder_id ? `?folder=${folder_id}` : "")
    const data = await r.json();
    return data
}

export function get_doc_thumb_url(doc_id: number) {
    return `${base_domain}/api/docs/${doc_id}/thumb.png`
}

async function toc(doc_id: number) {
    const r = await fetch(base_url + `docs/${doc_id}/toc`)
    const data = await r.json();

    return data.toc;
}

async function chapter_lessons(doc_id: number, chapter_id: number) {
    const r = await fetch(base_url + `docs/${doc_id}/chapter_lessons/${chapter_id}`)
    const data = await r.json()

    return data.chapter_lessons
}

// tracing

export interface Message {
    role: string //"system" | "user" | "assistant" | "tool"
    type: "text" | "image" | "audio"
    content: string
    edited?: boolean
    original?: string
}

async function save_chat(messages: Message[], chat_id: string | null) {
    const r = await fetch(base_url + 'docs/chat',
        {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ messages, chat_id: chat_id })
        }
    )
    const data = await r.json()

    return data.chat_id
}

export async function save_voice_msg(chat_id: string | null, msg_id: number, voice_msg: string) {
    const r = await fetch(base_url + 'docs/chat/voice_msg',
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                chat_id,
                msg_id,
                voice_msg
            })
        }
    )

    const data = await r.json()
    return data.chat_id
}

// legacy

async function fetch_legacy_doc(doc_id, doc_name) {
    const r = await fetch(base_url + `docs/legacy?user_id=${doc_id}&doc_id=${doc_name}` )
    return await r.json();
}

export default {
    dir_create, dir_get, dir_change, dir_delete,
    upload_doc, docs,
    toc, chapter_lessons,
    save_chat, save_voice_msg,
    fetch_legacy_doc
}
